import axios from "axios";

export const LOCAL_STORAGE_KEY = '337E35C2C6F7FE0516DBD3679C7E735DEA645F48CF971354A0D1FF9474AD403B'

/** Base da API com protocolo; sem http(s) o browser trata como path relativo ao front (URL errada). */
function normalizeApiBase(base) {
    let b = String(base || '').trim()
    if (!b) return ''
    if (!/^https?:\/\//i.test(b)) {
        b = 'http://' + b.replace(/^\/+/, '')
    }
    return b.endsWith('/') ? b : `${b}/`
}

export const API_URL = normalizeApiBase(process.env.REACT_APP_API_URL)

export const DOCS_URL = process.env.REACT_APP_DOCS_URL

export const request = async (url, method = 'GET', body, isFormData = false) => {
    const { token } = getInfoLocalStorage();
    const headers = {
        'Accept': 'application/json',
    }
    
    // Não definir Content-Type para FormData pois o navegador define automaticamente com boundary
    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
    }
    
    if (token) {
        headers.Authorization = `Bearer ${token}`
    }

    // Garantir que não haja barras duplicadas na URL
    let fullUrl = API_URL;
    if (fullUrl.endsWith('/') && url.startsWith('/')) {
        fullUrl = fullUrl + url.substring(1);
    } else if (!fullUrl.endsWith('/') && !url.startsWith('/')) {
        fullUrl = fullUrl + '/' + url;
    } else {
        fullUrl = fullUrl + url;
    }

    const config = {
        method,
        url: fullUrl,
        headers,
        data: body
    }
    
    // Se não for FormData e body existir, converte para JSON
    if (!isFormData && body !== undefined) {
        config.data = JSON.stringify(body);
    }

    const response = await axios(config)
    const result = response.data
    return result
}

export const getInfoLocalStorage = () => (
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {}
)

export const setInfoLocalStorage = (data) => {
    const infoFromLocalStorage = getInfoLocalStorage()
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
        ...infoFromLocalStorage,
        ...data
    }))
}

export const destroyInfoLocalStorage = () => (
    localStorage.removeItem(LOCAL_STORAGE_KEY)
)